import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgClass, NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'peps-overwatch-academy-logo',
	imports: [
		NgOptimizedImage,
		NgClass
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './overwatch-academy-logo.component.html',
})
export class OverwatchAcademyLogoComponent {

	@Input() width: number = 41;
	@Input() height: number = 48;
	@Input() hover: boolean = true;
	@Input() onClick: any = () => {};
}
